import React from 'react';
import { Panel } from "primereact/panel";
import { Accordion, AccordionTab } from 'primereact/accordion';
import * as generic from '../../../../components/Generico';
import { InstitucionEfectivo } from "../../../../components/trust/InstitucionEfectivo";
import { InstitucionInversion } from "../../../../components/trust/InstitucionInversion";
import { DeudaContraida } from "../../../../components/trust/DeudaContraida";
import { CreditoCobrar } from "../../../../components/trust/CreditoCobrar";
import { BottomActionBar } from "../../../../components/ui/BottomActionBar";

export const InformacionEconomica = ({ toast, id, permss, catalogos, soloLectura, handlePrev, handleNext }) => {

    return (
        <>
            <Panel header={generic.renderPanelHeader('6', 'SITUACIÓN ECONÓMICA (Activos Financieros y Pasivos)', 'pi pi-wallet')} className="panel-ficha shadow-2 mb-4">
                <div className="p-3">
                    <div className="bg-blue-50 p-3 border-round border-1 border-blue-200 mb-4 flex align-items-center gap-3">
                        <i className="pi pi-info-circle text-blue-500 text-xl"></i>
                        <p className="m-0 text-blue-800 text-sm">
                            Desglose de cuentas bancarias, inversiones, créditos a favor y deudas contraídas. <b>Haga clic en cada sección para expandirla.</b>
                        </p>
                    </div>

                    <Accordion multiple activeIndex={[0]}>
                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-money-bill text-blue-600 text-lg"></i>6.1.2.2 Dinero en Efectivo, Bancos y Otros</span>}>
                            <div className="bg-blue-50 p-3 border-round border-1 border-blue-100 mb-3 flex align-items-start gap-2">
                                <i className="pi pi-info-circle text-blue-500 mt-1"></i>
                                <span className="text-blue-800 text-sm">
                                    Todos los valores se reportarán en dólares. Si los valores en la cuenta o en efectivo están en otra moneda, se deberá realizar la valoración al tipo de cambio a la fecha.
                                </span>
                            </div>
                            <InstitucionEfectivo id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-chart-line text-blue-600 text-lg"></i>6.1.2.3 Inversiones</span>}>
                            <InstitucionInversion id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-file-export text-blue-600 text-lg"></i>6.1.2.4 Créditos por Cobrar</span>}>
                            <div className="bg-blue-50 p-3 border-round border-1 border-blue-100 mb-3 flex align-items-start gap-2">
                                <i className="pi pi-info-circle text-blue-500 mt-1"></i>
                                <span className="text-blue-800 text-sm">
                                    Detalle la lista de créditos por cobrar, con indicación de su monto, la identificación de los deudores y de las garantías otorgadas a favor suyo.
                                </span>
                            </div>
                            <CreditoCobrar id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                        <AccordionTab pt={{ headerIcon: { className: 'text-orange-600' } }} header={<span className="flex align-items-center gap-2"><i className="pi pi-credit-card text-orange-500 text-lg"></i><span className="font-bold text-orange-600">6.2 Pasivos</span></span>}>
                            <div className="bg-orange-50 p-3 border-round border-1 border-orange-200 mb-3 flex align-items-start gap-2">
                                <i className="pi pi-exclamation-circle text-orange-500 mt-1"></i>
                                <span className="text-orange-800 text-sm">
                                    <b>6.2.1 DESGLOSE DE DEUDAS CONTRAÍDAS:</b> Detalle la lista de obligaciones por pagar, con el nombre o razón social del acreedor, los respectivos valores y garantías de cada obligación de haberlas.
                                </span>
                            </div>
                            <DeudaContraida id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                    </Accordion>
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onNext={handleNext} isReadOnly={true} />
        </>
    );
}
